import { FC } from "react";

import ColumnRowTable from
  "apps/website/components/feature/Table/ColumnRowTable/ColumnRowTable";
import { getBrandImage } from "apps/website/utils/content/brands";
import { BRANDS } from "apps/website/constants/brands";

import { brandComparisonTableDataAlt } from "./shared/data";

export interface IBrandComparisonTable {
  highlightKatKin?: boolean;
}

const BrandComparisonTable: FC<IBrandComparisonTable> = ({ highlightKatKin }) => {

  const titles = brandComparisonTableDataAlt.titles.map(({ subheading, ...rest }) => ({
    ...rest,
    image: getBrandImage(rest.id as keyof typeof BRANDS),
  }));

  return (
    <ColumnRowTable
      component="BrandComparisonTable"
      highlightColumn={highlightKatKin ? 0 : undefined}
      columnTitles={titles}
      rows={brandComparisonTableDataAlt.rows}
    />
  );
};

export default BrandComparisonTable;
